import { useState } from "react";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

// Build 6B.1E / 6B.4D — participant-facing continuation into Diagnostic 2.
// Visibility is driven by server-side eligibility (`go_deeper_available`), so a
// controlled-test participant on the server allowlist sees it while global
// handoff stays OFF for the public. No client-side flag can force it on.
export function GoDeeper({ respondentId, available }) {
  const [busy, setBusy] = useState(false);
  if (!available || !respondentId) return null;

  const onGoDeeper = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await api.goDeeper(respondentId);
      if (res?.destination) {
        window.location.href = res.destination;
      } else {
        toast.error("We couldn't start your next step just now. Your results remain saved.");
        setBusy(false);
      }
    } catch {
      toast.error("We couldn't start your next step just now. Your results remain saved.");
      setBusy(false);
    }
  };

  return (
    <section className="no-print" data-testid="go-deeper-section">
      <div className="rounded-sm border-2 border-[#1408F7] bg-[var(--tw-blue-tint)] p-8 sm:p-12">
        <p className="tw-eyebrow text-[#1408F7]">Go deeper</p>
        <h2 className="mt-4 text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl">
          Your first diagnostic identified the pattern.
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-neutral-700">
          Now go deeper across Strategy, Systems and People to understand what may be driving it —
          and what to do next.
        </p>
        <button
          onClick={onGoDeeper}
          disabled={busy}
          className="tw-btn-primary tw-focus mt-8 inline-flex items-center gap-2 rounded-sm px-8 py-4 text-sm font-semibold uppercase tracking-wide disabled:opacity-50"
          data-testid="go-deeper-button"
        >
          {busy ? "Starting…" : "Go deeper"}
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </section>
  );
}
